export default "__VITE_ASSET__BlCae7Yc__"